<template>
  <div>
    <div class="font-size-14 color-complementary-400 margin-bottom-8">
      {{ data.title }}
    </div>
    <div
      class="overflow-x-auto background-surface margin-bottom-24"
    >
      <div
        class="table-grid-row font-size-12 color-complementary-300 padding-x-16 padding-y-8 margin-bottom-8 min-width-1200 border--solid border--complementary-50 border--x-0 border--top-0"
        :style="`grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidths};`"
      >
        <div
          class="width--max-content"
          v-for="({ label, isSortable }, index) in labels"
          :key="`a-${index}`"
        >
          <span class="">{{ label }}</span>
          <span v-if="isSortable" class="margin-right-8">
            <mdicon name="unfold-more-horizontal" size="16" />
          </span>
        </div>
      </div>
      <div class="table-body">
        <div
          v-for="(item, index) in data.items"
          :key="`b-${index}`"
          class="table-grid-row margin-bottom-8 padding-x-16 padding-y-4 last-child-border-radius-left-4"
          :style="`grid-template-columns: repeat(${labels.length}, 1fr); grid-template-columns: ${generateColumnWidths};`"
        >
          <span class="font-size-14 color-complementary-300">
            {{ item.title }}
          </span>
          <span class="font-size-14 color-complementary-300">
            {{ item.rankPercent }}
          </span>
          <span
            v-for="(item, index) in item.percentItems"
            :key="`c-${index}`"
            class="width-percent-100 height-20 background-primary"
            :class="{ 'border-radius-right-4': !index }"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, toRefs } from "vue";
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    // generate props data
    const { data } = toRefs(props);

    const labels = [
      {
        label: "عنوان",
        isSortable: false,
        width: "12%",
      },
      {
        label: "امتیاز (عددی)",
        isSortable: false,
        width: "12%",
      },
      {
        label: "0",
        isSortable: false,
        width: "6%",
      },
      {
        label: "10",
        isSortable: false,
        width: "6%",
      },
      {
        label: "20",
        isSortable: false,
        width: "6%",
      },
      {
        label: "30",
        isSortable: false,
        width: "6%",
      },
      {
        label: "40",
        isSortable: false,
        width: "6%",
      },
      {
        label: "50",
        isSortable: false,
        width: "6%",
      },
      {
        label: "60",
        isSortable: false,
        width: "6%",
      },
      {
        label: "70",
        isSortable: false,
        width: "6%",
      },
      {
        label: "80",
        isSortable: false,
        width: "6%",
      },
      {
        label: "90",
        isSortable: false,
        width: "6%",
      },
      {
        label: "100",
        isSortable: false,
        width: "6%",
      },
    ];
    const generateColumnWidths = computed(() =>
      labels.map(({ width }) => width).join(" ")
    );

    // return data to be used in template
    return { labels, generateColumnWidths, data };
  },
};
</script>
<style lang="scss">
.table-grid-row {
  display: grid;
  grid-template-rows: auto;
  align-items: start;
}
.table-body {
  min-width: 1200px;
}
.border-radius-right-4 {
  border-radius: 0 4px 4px 0;
}
.border-radius-left-4 {
  border-radius: 4px 0 0 4px;
}
.last-child-border-radius-left-4 {
  span:last-child {
    @extend .border-radius-left-4;
  }
}
</style>
